import { render } from "./NotaryJournalPDF.vue?vue&type=template&id=e8cbad2e&scoped=true"
import script from "./NotaryJournalPDF.vue?vue&type=script&lang=js"
export * from "./NotaryJournalPDF.vue?vue&type=script&lang=js"

import "./NotaryJournalPDF.vue?vue&type=style&index=0&id=e8cbad2e&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\eNotary.SPA\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8cbad2e"]])

export default __exports__